import React, { useMemo } from "react";
import { formatSsn } from "../../../_src_shared/utils/functions/formatSsn";
import { formatPhone } from "../../../_src_shared/utils/functions/formatPhone";
import { formatDate } from "../../../_src_shared/utils/functions/formatDate";
import { isNil } from "lodash";
import ProfileSection from "../components/ProfileSection";
import SidebarEditProfileDataIconButton from "../../../components/sidebars/DashboardSidebar/buttons/SidebarEditProfileDataIconButton";
import { PersonOutline } from "@mui/icons-material";
import Flx from "../../../components/layout/Flx";
import ProfileSectionContentCard from "../components/ProfileSectionContentCard";
import InfoGrid from "../../../components/ui/data/InfoGrid";
import Txt from "../../../components/typography/Txt";
import { useSelector } from "react-redux";

const ProfileBorrowerInfomationSection = ({ activeTab, keyName }) => {
  const profile = useSelector((state) => state.profile);
  const {
    firstName,
    middleName,
    lastName,
    dateOfBirth,
    emailAddress,
    phone,
    borrowerSSN,
    maritalStatus,
    primaryAddress,
    citizenshipStatus,
  } = profile;

  const displayedItems = useMemo(() => {
    return [
      { label: "First Name", value: firstName },
      {
        label: "Middle Name",
        value: isNil(middleName) || middleName === " " ? "-" : middleName,
      },
      { label: "Last Name", value: lastName },
      { label: "Date of Birth", value: formatDate(dateOfBirth) },
      { label: "Email", value: emailAddress },
      { label: "Phone", value: formatPhone(phone) },

      { label: "SSN", value: formatSsn(borrowerSSN) },
      { label: "Marital Status", value: maritalStatus },
      { label: "Citizenship Status", value: citizenshipStatus },
    ];
  }, [
    firstName,
    middleName,
    lastName,
    dateOfBirth,

    emailAddress,
    phone,
    borrowerSSN,
    maritalStatus,
    citizenshipStatus,
  ]);

  const contactItems = useMemo(() => {
    return [
      { label: "Email", value: emailAddress },
      { label: "Phone", value: formatPhone(phone) },
    ];
  }, [emailAddress, phone]);

  const addressItems = useMemo(() => {
    return [{ label: "Primary Address", value: primaryAddress?.fullAddress }];
  }, [primaryAddress]);

  return (
    <ProfileSection
      activeTab={activeTab}
      title={"My Information"}
      gap={0.5}
      endContent={<SidebarEditProfileDataIconButton />}
      icon={<PersonOutline />}
    >
      <Flx fw column gap={5}>
        <Flx column g={0.5}>
          <ProfileSectionContentCard>
            <InfoGrid width="260px" mb={1} items={displayedItems} />
          </ProfileSectionContentCard>
        </Flx>
        <Flx column g={0.5}>
          <Txt>Contact Information</Txt>
          <ProfileSectionContentCard>
            <InfoGrid mb={1} items={contactItems} />
          </ProfileSectionContentCard>
        </Flx>
        <Flx column g={0.5}>
          <Txt>Primary Address</Txt>
          <ProfileSectionContentCard>
            <InfoGrid mb={1} items={addressItems} />
          </ProfileSectionContentCard>
        </Flx>
      </Flx>
    </ProfileSection>
  );
};

export default ProfileBorrowerInfomationSection;
